<template>
  <v-container>
    <h1>Announcements</h1>
    <p>I made a new project</p>
  </v-container>
</template>

<script>
export default {
	name: 'Announcements'
}
</script>

<style>

</style>